import type { FilterBarProps } from "shared-ui/src/components/filter-bar/FilterBar";
import { GridSortModel } from "@mui/x-data-grid-pro";
import { DateTime } from "luxon";

export const ORDER_DATE_RANGE_MAX_YEARS = 5;

function getDefaultDateRange(): [string, string] {
  // Order dates are stored and displayed anchored to UTC (see parseOrderDate),
  // so the default range must use the UTC calendar day. Using local time would
  // exclude late-evening US orders whose UTC date is already the next day.
  const today = DateTime.utc();
  const date90DaysAgo = today.minus({ days: 90 });
  return [date90DaysAgo.toISODate()!, today.toISODate()!];
}

export const DEFAULT_FILTER: FilterBarProps = {
  include: { orderDateRange: getDefaultDateRange() },
  exclude: {},
};

export const DEFAULT_SORT: GridSortModel[number] = {
  field: "orderDate",
  sort: "desc",
};

export const FILTER_LABELS: Record<string, string> = {
  salesOrder: "Sales Order",
  orderNumber: "Sales Order",
  status: "Status",
  invoiceStatus: "Invoice Status",
  purchaseOrder: "Purchase Order",
  purchaseOrderNumber: "Purchase Order",
  orderedBy: "Ordered By",
  shipTo: "Ship To",
  orgUnitIds: "Storefront",
};

export const FILTER_CATEGORY_DATE_RANGE = "orderDateRange";
